module.exports = __webpack_public_path__ + "static/img/piano-player.e6af7e8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/school-hall/piano-player.svg
// module id = 182
// module chunks = 2